import style from "./ShipmentDestination.module.css";

function ShipmentDestination({
  destination,
  source,
  transitTime,
  deliveryType,
}) {
  return (
    <div className={style.box}>
      <div className={"bg-avaex-second " + style.header}>
        <span>آدرس</span>
      </div>
      <div className="p-2">
        <h5>مبدا</h5>
        <p className={style.source}>
          <span>کشور: </span>
          <span>ایران </span>
          <span>استان: </span>
          <span>{source.province.faName} </span>
          <span>شهر: </span>
          <span>{source.city.faName}</span>
        </p>
        <h5>مقصد</h5>
        <p className={style.source}>
          <span>کشور: </span>
          <span>{`${destination.country.faName} (${destination.country.enName})`}</span>
          <span>شهر: </span>
          <span>{`${destination.address_external.fa_city_name} (${destination.address_external.en_city_name})`}</span>
        </p>
      </div>

      <p className="px-2 pb-3">
        <span>مدت زمان تحویل: </span>
        <span className="fs-6 fw-semibold">{transitTime}</span>
        <span className="me-3">نوع تحویل: </span>
        <span className="fs-6 fw-semibold">
          {deliveryType === 1 ? "فرودگاهی" : "درب تا درب"}
        </span>
      </p>
    </div>
  );
}

export default ShipmentDestination;
